<ng-container *ngIf="!showForgotPass">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <!-- Email -->
    <div class="form-group with-icon">
      <label for="email">{{'TEAM_SIGN_IN.EMAIL' | translate}} <span class="req">*</span></label>
      <i class="icon custom-c-mail"></i>
      <input id="email" type="email" formControlName="email" class="form-control" autocomplete="off"/>
      <div *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
        <small *ngIf="form.get('email')?.errors?.['required']" class="text-danger">
          {{'TEAM_SIGN_IN.ERRORS.EMAIL_REQUIRED' | translate}}
        </small>
        <small *ngIf="form.get('email')?.errors?.['email']" class="text-danger">
          {{'TEAM_SIGN_IN.ERRORS.EMAIL_INVALID' | translate}}
        </small>
      </div>
    </div>

    <!-- Password -->
    <div class="form-group mt-2">
      <label for="password">{{'TEAM_SIGN_IN.PASSWORD' | translate}} <span class="req">*</span></label>
      <input id="password" class="form-control" autocomplete="off"
             formControlName="password" [type]="showPassword ? 'text' : 'password'"/>
      <i class="icon password-icon"
         [ngClass]="{'icon-eye': showPassword, 'icon-eye-closed': !showPassword}"
         (click)="togglePasswordVisibility()"></i>
      <div *ngIf="form.get('password')?.touched && form.get('password')?.invalid">
        <small *ngIf="form.get('password')?.errors?.['required']" class="text-danger">
          {{'TEAM_SIGN_IN.ERRORS.PASSWORD_REQUIRED' | translate}}
        </small>
      </div>
    </div>
    <small *ngIf="error" class="text-danger">
      {{'TEAM_SIGN_IN.ERRORS.GENERIC' | translate}}
    </small>

    <p class="forgot-link mt-3" (click)="toggleForgotPassword()">{{'TEAM_SIGN_IN.FORGOT_PASSWORD' | translate}}</p>

    <div class="button-wrap">
      <button type="submit" class="btn btn-primary-henterpant with-loader" [disabled]="!form.valid">
        {{'TEAM_SIGN_IN.BUTTON' | translate}} <span class="loader" *ngIf="loading"></span>
      </button>
    </div>
  </form>
</ng-container>

<app-forgot-password *ngIf="showForgotPass" [henterPantMode]="henterPantMode"
                     (goToLogin)="showForgotPass = !showForgotPass"></app-forgot-password>
